import { CrudEndpoint } from './crud.endpoint';

export class ChannelsEndpoint extends CrudEndpoint {
	constructor() {
		super('channels');
	}
}
